import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import AuthPanel from "@/components/AuthPanel";
import Logo from "@/components/Logo";
import usePageTitle from "@/lib/usePageTitle";

export default function Login() {
  usePageTitle("Anmelden");
  const navigate = useNavigate();
  const { checkAuth } = useAuth();

  const onSuccess = async (user) => {
    await checkAuth();
    if (user.role === "platform_admin") navigate("/admin", { replace: true });
    else if (user.role === "tenant_driver") navigate("/driver", { replace: true });
    else if (["tenant_owner", "tenant_staff"].includes(user.role)) navigate("/app", { replace: true });
    else if (user.role === "customer" && user.tenant_slug) navigate(`/portal/${user.tenant_slug}/account`, { replace: true });
    else navigate("/me", { replace: true });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--tonneva-bg)] px-6 relative overflow-hidden">
      <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full opacity-20 blur-3xl" style={{ background: "var(--tonneva-gradient)" }} />
      <div className="absolute -bottom-32 -left-32 w-[400px] h-[400px] rounded-full opacity-20 blur-3xl" style={{ background: "var(--tonneva-gradient)" }} />
      <div className="w-full max-w-md relative">
        <div className="bg-white rounded-2xl p-10 shadow-xl border border-[var(--tonneva-border)]">
          <div className="flex justify-center mb-6"><Logo size={56} withText={false} /></div>
          <h1 className="font-heading text-3xl font-black tracking-tight text-center mb-1">Willkommen.</h1>
          <p className="text-sm text-[var(--tonneva-muted)] mb-8 text-center">
            Melden Sie sich an, um Ihr Tonneva-Dashboard zu öffnen.
          </p>
          <AuthPanel onSuccess={onSuccess} googleRedirectPath="/me" />
        </div>
        <p className="text-center text-xs text-[var(--tonneva-muted)] mt-6">
          <a href="/" className="hover:text-[var(--tonneva-primary)] underline underline-offset-4">← zurück zur Startseite</a>
        </p>
      </div>
    </div>
  );
}
